import React,{useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Joverload(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
    <Sides/>
    <Helmet>
 
  <title>Java Method overloading tutorial For Beginners</title>
<meta name="description" content="Java overloading tutorial for beginners.overloading java method is the example of compile-time polymorphism and this is also known as a static polymorphism in java." />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,java overloading,method overloading in java
,java overloading methods,constructor overloading in java,java overloading operators,java override tostring,java overloading vs overriding,overloading and overriding in java,java overloading methods example
,java overloading overriding,java overloading program
,java program for method overloading,java overloading and overriding interview questions,java overloading nedir,is java support operator overloading,static polymorphism" />
<link rel="canonical" href="https://www.codeexampler.com/java-overloading" />
</Helmet>

<div className='lg:pl-56'>


    <h1 className="m-4 mh1">Method overloading in java</h1>
    <div className="first">
        <a href="/java-association">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-overriding">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
<p className="mt-4 para">Overloading java method is the example of compile-time polymorphism and this is also known as a <span className="bold"> static polymorphism in java.</span></p>
<h2 className="mt-4 mh2">Rules of overloading java method:</h2>
<h3 className="mt-4 mh3">1, If you call two methods so both methods place inside the  same class<br/>
2, Two or multiple method names are same<br/>
3, Two or multiple method arguments are different means you change <br/>
</h3>
<h4 className="mt-4">A, Sequence of argument<br/>
B, Numbers of argument<br/>
C, Type of argument<br/>
</h4>



<h2 className='headings'>Q-Write a Program no of argument example in method overloading?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty">class </span>
                <span className="qwerty-4">overload </span>
            {"\n"}
                <span className="qwerty-1" >&#123;</span>
            {"\n"}
                <span className="qwerty-3">  void </span>
                <span className="qwerty-8">over</span>
                <span className="qwerty-10">()</span>
                <span className="qwerty-1" >&#123;</span>
            {"\n"}
                <span className="qwerty-6">    System.out.println</span>
                <span className="qwerty-1">("</span>
                <span className="qwerty-10">1 over</span>
                <span className="qwerty-1">")</span>
                <span className="qwerty-1">;</span>
            {"\n"}
                <span className="qwerty-1" >  &#125;</span>
            {"\n"}
                <span className="qwerty-3">  void </span>
                <span className="qwerty-8">over</span>
                <span className="qwerty-10">(</span>
                <span className="qwerty-7">String </span>
                <span className="qwerty-4">x</span>
                <span className="qwerty-10">)</span>
                <span className="qwerty-5"> //give one arguement</span>
            {"\n"}
                <span className="qwerty-1" >  &#123;</span>
            {"\n"}
                <span className="qwerty-6">    System.out.println</span>
                <span className="qwerty-1">("</span>
                <span className="qwerty-10">2 over</span>
                <span className="qwerty-1">")</span>
                <span className="qwerty-1">;</span>
            {"\n"}
                <span className="qwerty-1" >  &#125;</span>
            {"\n"}        
                    <span className="qwerty-7">  public </span>
                    <span className="qwerty">static </span>
                    <span className="qwerty-3">void </span>
                    <span className="qwerty-8">main</span>
                    <span className="qwerty-1">(</span>
                    <span className="qwerty-2">String</span>
                    <span className="qwerty-6">[]</span>
                    <span className="qwerty-4">args</span>
                    <span className="qwerty-1">)</span>
            {"\n"}
                <span className="qwerty-1" >  &#123;</span>
            {"\n"}
                    <span className="qwerty-4">    overload </span>
                    <span className="qwerty-5">o</span>
                    <span className="qwerty-1"> = </span>
                    <span className="qwerty">new </span>
                    <span className="qwerty-4">overload</span>
                    <span className="qwerty-10">()</span>
                    <span className="qwerty-1">;</span>
            {"\n"}
                <span className="qwerty-5">    o</span>
                <span className="qwerty-1">.</span>
                <span className="qwerty-8">over</span>
                <span className="qwerty-10">()</span>
                <span className="qwerty-1">;</span>        
                    {"\n"}                             {"\n"}          
                         <span className="qwerty-1" >  &#125;</span>
                    {"\n"}          
                         <span className="qwerty-1" >&#125;</span>
                {"\n"}{"\n"}      
        </code>
        </pre>
        </div>          
        <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-3">1 over</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div>

<p className="mt-4 para">when we call over() method so on that time inside this method no argument passed so this method  call  no argument method</p>



<h2 className='headings'>Q-Write a Program the sequence of argument change?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty">class </span>
                <span className="qwerty-4">overload </span>
            {"\n"}
                <span className="qwerty-1" >&#123;</span>
            {"\n"}
                <span className="qwerty-3">  void </span>
                <span className="qwerty-8">over</span>
                <span className="qwerty-10">(</span>
                <span className="qwerty-7">int </span>
                <span className="qwerty-4">a</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-7">String </span>
                <span className="qwerty-4">x</span>
                <span className="qwerty-10">)</span>
                <span className="qwerty-5"> // give 2 arguement but first integer and the second string</span>
            {"\n"}
                <span className="qwerty-1" >  &#123;</span>
            {"\n"}
                <span className="qwerty-6">    System.out.println</span>
                <span className="qwerty-1">("</span>
                <span className="qwerty-10">1 over</span>
                <span className="qwerty-1">")</span>
                <span className="qwerty-1">;</span>
            {"\n"}
                <span className="qwerty-1" >  &#125;</span>
            {"\n"}
                <span className="qwerty-3">  void </span>
                <span className="qwerty-8">over</span>
                <span className="qwerty-10">(</span>
                <span className="qwerty-7">String </span>
                <span className="qwerty-4">x</span>
                <span className="qwerty-1">,</span>
                <span className="qwerty-7">int </span>
                <span className="qwerty-4">a</span>
                <span className="qwerty-10">)</span>
                <span className="qwerty-5"> // give 2 arguement but first string and the second integer</span>
            {"\n"}
                <span className="qwerty-1" >  &#123;</span>
            {"\n"}
                <span className="qwerty-6">    System.out.println</span>
                <span className="qwerty-1">("</span>
                <span className="qwerty-10">2 over</span>
                <span className="qwerty-1">")</span>
                <span className="qwerty-1">;</span>
            {"\n"}
                <span className="qwerty-1" >  &#125;</span>
            {"\n"}        
                    <span className="qwerty-7">  public </span>
                    <span className="qwerty">static </span>
                    <span className="qwerty-3">void </span>
                    <span className="qwerty-8">main</span>
                    <span className="qwerty-1">(</span>
                    <span className="qwerty-2">String</span>
                    <span className="qwerty-6">[]</span>
                    <span className="qwerty-4">args</span>
                    <span className="qwerty-1">)</span>
            {"\n"}
                <span className="qwerty-1" >  &#123;</span>
            {"\n"}
                    <span className="qwerty-4">    overload </span>
                    <span className="qwerty-5">o</span>
                    <span className="qwerty-1"> = </span>
                    <span className="qwerty">new </span>
                    <span className="qwerty-4">overload</span>
                    <span className="qwerty-10">()</span>
                    <span className="qwerty-1">;</span>
            {"\n"}
                <span className="qwerty-5">    o</span>
                <span className="qwerty-1">.</span>
                <span className="qwerty-8">over</span>
                <span className="qwerty-10">(</span>
                <span className="qwerty-2">25</span>
                <span className="qwerty-1">,"</span>
                <span className="qwerty-3">Ram</span>
                <span className="qwerty-1">"</span>        
                <span className="qwerty-10">)</span>
                <span className="qwerty-1">;</span>        
                <span className="qwerty-5" >//check and call first string and second integer arguement method</span>
                    {"\n"}          
                         <span className="qwerty-1" >  &#125;</span>
                    {"\n"}          
                         <span className="qwerty-1" >&#125;</span>
                {"\n"}{"\n"}      
        </code>
        </pre>
        </div>          
        <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-3">1 over</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div>


<h2 className='headings'>Q-Write a Program type of arguement?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty">class </span>
                <span className="qwerty-4">overload </span>
            {"\n"}
                <span className="qwerty-1" >&#123;</span>
            {"\n"}
                <span className="qwerty-3">  void </span>
                <span className="qwerty-8">over</span>
                <span className="qwerty-10">(</span>
                <span className="qwerty-7">int </span>
                <span className="qwerty-4">a</span>
                <span className="qwerty-10">)</span>
                <span className="qwerty-5"> // give 1 arguement but this is an integer</span>
            {"\n"}
                <span className="qwerty-1" >  &#123;</span>
            {"\n"}
                <span className="qwerty-6">    System.out.println</span>
                <span className="qwerty-1">("</span>
                <span className="qwerty-10">int overload</span>
                <span className="qwerty-1">")</span>
                <span className="qwerty-1">;</span>
            {"\n"}
                <span className="qwerty-1" >  &#125;</span>
            {"\n"}
                <span className="qwerty-3">  void </span>
                <span className="qwerty-8">over</span>
                <span className="qwerty-10">(</span>
                <span className="qwerty-7">String </span>
                <span className="qwerty-4">x</span>
                <span className="qwerty-10">)</span>
                <span className="qwerty-5"> // give 1 arguement but this is string</span>
            {"\n"}
                <span className="qwerty-1" >  &#123;</span>
            {"\n"}
                <span className="qwerty-6">    System.out.println</span>
                <span className="qwerty-1">("</span>
                <span className="qwerty-10">string overload</span>
                <span className="qwerty-1">")</span>
                <span className="qwerty-1">;</span>
            {"\n"}
                <span className="qwerty-1" >  &#125;</span>
            {"\n"}        
                    <span className="qwerty-7">  public </span>
                    <span className="qwerty">static </span>
                    <span className="qwerty-3">void </span>
                    <span className="qwerty-8">main</span>
                    <span className="qwerty-1">(</span>
                    <span className="qwerty-2">String</span>
                    <span className="qwerty-6">[]</span>
                    <span className="qwerty-4">args</span>
                    <span className="qwerty-1">)</span>
            {"\n"}
                <span className="qwerty-1" >  &#123;</span>
            {"\n"}
                    <span className="qwerty-4">    overload </span>
                    <span className="qwerty-5">o</span>
                    <span className="qwerty-1"> = </span>
                    <span className="qwerty">new </span>
                    <span className="qwerty-4">overload</span>
                    <span className="qwerty-10">()</span>
                    <span className="qwerty-1">;</span>
            {"\n"}
                <span className="qwerty-5">    o</span>
                <span className="qwerty-1">.</span>
                <span className="qwerty-8">over</span>
                <span className="qwerty-10">(</span>
                <span className="qwerty-1">"</span>
                <span className="qwerty-3">Har-Har-Mahadev</span>
                <span className="qwerty-1">"</span>        
                <span className="qwerty-10">)</span>
                <span className="qwerty-1">;</span>        
                <span className="qwerty-5" >//check and call first string and second integer arguement method</span>
                    {"\n"}          
                         <span className="qwerty-1" >  &#125;</span>
                    {"\n"}          
                         <span className="qwerty-1" >&#125;</span>
                {"\n"}{"\n"}      
        </code>
        </pre>
        </div>          
        <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-3">string overload</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div>

  <h1 className="mt-5">  </h1>
   
  <div className="back">
        <a href="/java-association">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-overriding">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Joverload;